import { TransactionStatus } from "@/data/constants";

export const TransactionStatusMapped = (status?: any) => {
  switch (status) {
    case TransactionStatus.OK:
    case TransactionStatus.CONFIRMED:
      return {
        type: "is-success",
        icon: "check-circle",
        class: "has-text-success"
      };
    case TransactionStatus.ERROR:
    case TransactionStatus.EXPIRED:
    case TransactionStatus.FRAUD:
      return {
        type: "is-danger",
        icon: "exclamation-circle",
        class: "has-text-danger"
      };
    case TransactionStatus.REDIRECT:
      return {
        type: "is-info",
        icon: "arrow-circle-right",
        class: "has-text-info"
      };
    case TransactionStatus.THREE_D_AUTH:
      return {
        type: "is-info",
        icon: "fingerprint",
        class: "has-text-info"
      };
    case TransactionStatus.PENDING:
    case TransactionStatus.WAITING:
      return {
        type: "is-dark",
        icon: "pause-circle",
        class: "has-text-dark"
      };
    default:
      return {
        type: "is-dark",
        icon: "dot-circle",
        class: "has-text-dark"
      };
  }
};
